export const SAVED_BY_YOU_TAB_ITEM = {
  name: 'Saved By You',
  slug: 'saved-by-you',
};

export const CREATED_BY_YOU_TAB_ITEM = {
  name: 'Created By You',
  slug: 'created-by-you',
};

export const YOUR_SCHOOL_TAB_ITEM = {
  name: 'At Your School',
  slug: 'at-your-school',
};

export const TAB_ITEMS = [
  SAVED_BY_YOU_TAB_ITEM,
  CREATED_BY_YOU_TAB_ITEM,
  YOUR_SCHOOL_TAB_ITEM,
];
